import React from 'react';

import type { TextOnlyHeroEntry } from 'schema';
import { TextOnlyHero } from '.';

export const ContentfulTextOnlyHero = ({ ...props }: TextOnlyHeroEntry) => (
  <TextOnlyHero {...props} />
);
